export const STANDALONE_DASHBOARD_TYPES = {
  ENTITIES: 'Entity',
  FORMS: 'Forms',
  SAVED_SEARCHES: 'Saved Searches',
  REPORTS: 'Reports',
  REPORT_MODELS: 'Report Models',
};
